import { all, call, put, takeLatest } from 'redux-saga/effects'
import {
  fetchNoticeConfig,
  evaluateMaintenance,
  getMaintenanceNow,
  type NoticeConfig,
  type MaintenanceScreen,
} from 'services/maintenance'

import actions from './actions'
import { FetchPayload } from './types'

interface FetchAction {
  type: string
  payload: FetchPayload
}

export function* FETCH(action: FetchAction): Generator {
  const { url } = action.payload
  const config = (yield call(fetchNoticeConfig, url)) as NoticeConfig | null
  const currentVersion = (import.meta.env.VITE_APP_VERSION as string) || '0.0.0'
  const screen: MaintenanceScreen = evaluateMaintenance({
    config,
    currentVersion,
    now: getMaintenanceNow(),
  })
  yield put({ type: actions.SET_STATE, payload: { screen } })
}

export default function* rootSaga(): Generator {
  yield all([takeLatest(actions.FETCH, FETCH)])
}
